import { qs, qsa } from '../utils'
import bidello from '../bidello'
import gsap, { Power4 } from 'gsap'
import menu from '../menu'
import scroll from '../animations/scroll/locomotiveScroll'

export const singleInspireTransition = {
  name: 'inspire-single',

  to: {
    namespace: 'inspire-single',
  },

  once({ next }) {
    const tl = animation(next.container)

    bidello.on('loaderEnd', () => {
      tl.play()
    })
  },

  enter({ next, current }) {
    current.container.style.display = 'none'

    const tl = animation(next.container)

    return tl.play()
  },

  leave({ next, current }) {
    if (menu.isOpen) {
      menu.menuLeave()
    }

    gsap.set(next.container, { autoAlpha: 0 })

    return gsap.to(current.container, {
      opacity: 0,
      duration: 1.2,
      onComplete: () => {
        scroll.scrollTo({ target: 0, options: { duration: 0, disableLerp: true } })
      }
    })
  }
}

const animation = (container) => {

  const label = qs('p', container)
  const title = qs('h1', container)
  const lines = qsa('.line', container)
  const footer = qs('.c-hero__footer', container)
  const images = qsa('[data-float]', container)
  const content = qs('.c-single-inspire__content', container)

  const tl = gsap.timeline({ paused: true })

  tl
    .set(container, { autoAlpha: 1 })
    .add('start')
    .from(title, {
      duration: 1.6,
      yPercent: 100,
      ease: Power4.easeOut
    })
    .from(lines, {
      duration: 1.2,
      scaleX: 0,
      ease: Power4.easeOut
    }, 'start+=0.6')
    .from(label, {
      duration: 1.6,
      yPercent: 100,
      ease: Power4.easeOut
    }, 'start+=1')
    .from(footer, {
      duration: 1.6,
      autoAlpha: 0,
      ease: Power4.easeOut
    }, 'start+=1.2')
    .from(content, {
      autoAlpha: 0,
      duration: 1.6,
      ease: Power4.easeOut
    }, 'start+=1.4')
    .from(images, {
      duration: 1.6,
      yPercent: 100,
      x: (i) => i % 2 === 0 ? `-${window.innerWidth / 3}px` : `${window.innerWidth / 3}px`,
      ease: Power4.easeOut,
      onComplete: () => {
        const elements = images

        elements.forEach(el => {
          el.setAttribute('animate', '')
          el.style.animationDelay = `${Math.random()}s`
        })
      }
    }, 'start+=1.4')

  return tl
}